var render = function render(){var _vm=this,_c=_vm._self._c;return _c('image-input',{attrs:{"image-type":'avatar'}})
}
var staticRenderFns = []

export { render, staticRenderFns }